import { useNavigate } from 'react-router-dom';

import { useToast } from "@/components/ui/use-toast"
import { useAppDispatch } from '@/store/hooks';
import { signOut } from '@/store/features/auth/auth-slice';

export const useSignOut = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { toast } = useToast();

  const triggerSignOut = () => {
    dispatch(signOut());
    toast({
      variant: "success",
      title: "Muvaffaqiyat!",
      description: "Sessiya muvaffaqiyatli tugatildi!",
    });
    navigate('/');
  }

  return {
    triggerSignOut,
  };
};
